
function generatecode() {
  let randomNumber = '';
  for (let i = 0; i < 4; i++) {
    randomNumber += Math.floor(Math.random() * 10);
  }
  return randomNumber;
}

export default generatecode